<template>
  <div class="home-container">
    <div class="home-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="home-main">
      <!--团队-->
      <team />
      <!--全案咨询-->
      <consultation />
      <!--客户案例-->
      <caseList />
    </div>
  </div>
</template>

<script setup>
import { ref} from 'vue'
import {getBannerList} from "@/api/apiHome";
import team from './components/team.vue'
import consultation from  './components/consultation.vue'
import caseList from "./components/caseList.vue"
import carousel from '@/components/carousel/index.vue'
const bannerList=ref([])
const queryBannerList=async ()=>{
  const {code,data}=await getBannerList(0)
  if(code===200){
    bannerList.value=data
  }
}
queryBannerList()
</script>

<style scoped lang="scss">

.home-container {
  box-sizing: border-box;
}
.home-top{
  height: 100vh;
  overflow: hidden;
}
.home-main{
  box-sizing: border-box;
}
</style>
